import React from 'react';

import { PrivacyContent } from '../content/privacyContent';
import LegalPageLayout from '../layouts/LegalPageLayout';

export default function PrivacyPolicy() {
  return (
    <LegalPageLayout title="Privacy Policy">
      <PrivacyContent />
    </LegalPageLayout>
  );
}
